module.exports = __webpack_public_path__ + "img/2.1a4b932c.png";